import styled from 'styled-components';
import {Layout} from "antd";

export const StyledHeader = styled(Layout.Header)`
  height: 88px;
  padding: 0;
  background-color: #fff;
  box-shadow: 0 16px 24px -6px rgba(27, 36, 44, 0.16);
  z-index: 99;
  position: fixed;
  width: 100%;

  .adaptiveLogo{
    display: none;
  }
  
  .areaCurrentIcon {
    position: absolute;
    bottom: -20px;
    left: 8px;

    @media (max-width: 736px) {
      left: 0;
    }
    
    @media (max-width: 597px) {
      bottom: -24px;
      left: 0;
    }

    @media (max-width: 577px) {
      display: none;
    }
  }

  @media(max-width: 577px){
    height: 72px;
    
    .adaptiveLogo {
      width: 100px;
      height: 40px;

      svg {
        width: 100px;

        height: 40px;
      }
    }
  }
  
  @media (max-width: 678px) {
    .adaptiveLogo{
      display: flex;
    }
    
    .normalLogo{
      display: none;
    }
  }

  @media(max-width: 379px){
    svg {
      width: 32px;
      height: 32px;
    }

    .adaptiveLogo {
        width: 80px;
      svg {
        width: 80px;

        height: 40px;
      }
    }
  }
  
  
  
  .serviceArea{
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: 1px;
    transition: 200ms;
    text-decoration: underline;
    color: #1D67A4;

    @media (max-width: 736px) {
      font-size: 18px;
    }
     
    &:hover{
    transition: 200ms;
      color: #003399;
      cursor: pointer;
    }
  }
`

export const StyledCallUsContainer = styled.div`
  display: flex;
  padding: 8px 16px 8px 8px;
  align-items: center;
  background-color: #003399;
  border-radius: 40px;
  margin-left: 64px;
  
  &:hover{
    cursor: pointer;
  }
  
  @media(max-width: 736px){
      margin-left: 24px !important;
  }
  
  @media (max-width: 596px) {
  }

  @media(max-width: 466px){
    padding: 4px 10px 4px 8px;
    margin-left: 4px !important;
  }

  @media(max-width: 379px){
    padding: 4px 6px 4px 6px;
    margin-left: 8px !important;
    
    svg{
      width: 24px;
      height: 24px;
    }
  }

  @media(max-width: 325px){
    margin-left: 6px !important;
  }

  .phoneNumber {
    margin-left: 12px;
    font-size: 24px;
    line-height: 24px;
    letter-spacing: 1px;
    font-weight: 600;
    color: #fff;


    @media(max-width: 622px){
      font-size: 20px;
    }

    @media(max-width: 466px){
      font-size: 18px;
    }

    @media(max-width: 403px){
      font-size: 16px;
    }

    @media(max-width: 389px){
      font-size: 14px !important;
    }
    
    
  }

  @media (max-width: 379px){
    margin-left: 12px;
    
    .phoneNumber{
      font-size: 16px;
      line-height: 24px;
    }
  }
`